import Create from "../Create/create";
import Intro from "../Intro/intro";
import Join from "../Join/join";
import User from "../User/user";
import styles from "./panel.module.css";
import { MyContext } from "../../component/utils/utils";
import { useContext, useRef, useEffect } from "react";

const Panel = ({}) => {
  return (
    <div className={styles.panel}>
      <Intro />
      <Join />
    </div>
  );
};

export default Panel;
